import * as Styles from './styles';

export const ChatComponent = () => {
  return (
    <Styles.Container>
      <Styles.ContainerChat></Styles.ContainerChat>
      <div className="input-group mt-2">
        <input
          type="text"
          className="form-control"
          placeholder="Escreva sua mensagem..."
          aria-label="Escreva sua mensagem..."
          aria-describedby="button-addon2"
        />
        <button className="btn btn-outline-secondary" type="button" id="button-addon2">
          Enviar
        </button>
      </div>
    </Styles.Container>
  );
};
